/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Empty_MembersInputs */

const en_team_empty_members = /** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No team members yet. Invite your first staff member above.`)
};

const es_team_empty_members = /** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay miembros del equipo. Invita a tu primer miembro arriba.`)
};

const fr_team_empty_members = /** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun membre d'équipe pour le moment. Invitez votre premier membre ci-dessus.`)
};

const de_team_empty_members = /** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Teammitglieder. Lade oben dein erstes Teammitglied ein.`)
};

const id_team_empty_members = /** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada anggota tim. Undang anggota staf pertama Anda di atas.`)
};

/** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */
const ja_team_empty_members = en_team_empty_members;

/** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */
const zh_team_empty_members = en_team_empty_members;

/** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */
const ar_team_empty_members = en_team_empty_members;

/** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */
const it_team_empty_members = en_team_empty_members;

/** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */
const ru_team_empty_members = en_team_empty_members;

/** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */
const pt_team_empty_members = en_team_empty_members;

/** @type {(inputs: Team_Empty_MembersInputs) => LocalizedString} */
const ko_team_empty_members = en_team_empty_members;

/**
* | output |
* | --- |
* | "No team members yet. Invite your first staff member above." |
*
* @param {Team_Empty_MembersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_empty_members = /** @type {((inputs?: Team_Empty_MembersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Empty_MembersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_empty_members(inputs)
	if (locale === "es") return es_team_empty_members(inputs)
	if (locale === "fr") return fr_team_empty_members(inputs)
	if (locale === "de") return de_team_empty_members(inputs)
	if (locale === "ja") return ja_team_empty_members(inputs)
	if (locale === "zh") return zh_team_empty_members(inputs)
	if (locale === "ar") return ar_team_empty_members(inputs)
	if (locale === "id") return id_team_empty_members(inputs)
	if (locale === "it") return it_team_empty_members(inputs)
	if (locale === "ru") return ru_team_empty_members(inputs)
	if (locale === "pt") return pt_team_empty_members(inputs)
	return ko_team_empty_members(inputs)
});